import * as React from "react";
import { offerType } from "../../app";
import InputForm from "../../common/components/html/inputForm";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import commonContext, { AppContext } from "../../common/context/common";
import htmlParse from "html-react-parser";
import { CommonApis } from "../../common/apis/commonApis";
import SelectForm from "../components/html/selectForm";

interface IProps {
    history: any;
}

interface IState {
    firstName: string;
    lastName: string;
    mobile: string;
    email: string;
    city: string;
    loanRequired: string;
    captcha: string;
    encryptedValue: string;
    iv: string;
    captchaInput: string;
    consentToContact: boolean;
    cityList: Array<object>;
    consentToContactError: boolean;
    encryptedInput?: string;
}
class higherLoanApplyForm extends React.Component<IProps, IState> {
    static contextType = commonContext;
    commonAPI: CommonApis;
    apis: any;
    offer: offerType;
    setLead: Function;
    constructor(props: IProps) {
        super(props);
        this.state = {
            firstName: "",
            lastName: "",
            mobile: "",
            email: "",
            city: "",
            consentToContact: false,
            loanRequired: "",
            captcha: "",
            encryptedValue: "",
            iv: "",
            captchaInput: "",
            cityList: [],
            consentToContactError: false,
        };
    }
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.offer = (this.context as AppContext).offer as offerType;
        this.commonAPI = (this.context as AppContext).commonAPI as CommonApis;
        this.apis = (this.context as AppContext).apis;
        this.setLead = (this.context as AppContext).setLead;
        const apiData = await this.commonAPI.getCaptcha({ temp: "" });
        let captchaValues = {};
        if (!apiData?.error?.error && apiData?.result) {
            captchaValues = {
                captcha: apiData.result.img,
                encryptedInput: "",
                encryptedValue: apiData.result.encryptedValue,
                iv: apiData.result.iv,
            };
        }
        const citiesList = await this.apis.getCities(this.offer);
        console.log(citiesList);

        this.setState({
            firstName: this.offer.pdApplicantFirstName,
            lastName: this.offer.pdApplicantLastName,
            mobile: this.offer.mobile,
            email: this.offer.email,
            city: this.offer.pdPresentCity,
            loanRequired: this.offer.loanAmt,
            ...captchaValues,
            cityList: citiesList.result,
        });
    }
    handleOnSubmit = async (e) => {
        e.preventDefault();
        this.setState({ consentToContactError: false });
        if (!this.state.consentToContact) {
            return this.setState({ consentToContactError: true });
        }
        if (
            this.state.consentToContact &&
            this.state.firstName &&
            this.state.lastName &&
            this.state.mobile &&
            this.state.email &&
            this.state.loanRequired
        ) {
            let resp = await this.commonAPI.updateHigherLoan({
                ...this.offer,
                ...this.state,
            });
            if (!resp?.error?.error) {
                this.setLead({
                    ...this.offer,
                    ...this.state,
                });
                this.props.history.push("higher-loan-thank-you");
            } else {
                this.props.history.push("error");
            }
        }
    };
    handleOnCaptchaReset = async () => {
        const apiData = await this.commonAPI.getCaptcha({ temp: "" });
        this.setState({ captcha: apiData.result?.img });
    };
    render() {
        this.offer = (this.context as AppContext).offer as offerType;
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="higher-loan mt-110">
                        <div className="container mx-auto px-5">
                            <h1 className="openSans-Reg text-black my-5 mt-5 md:my-5 md:mt-5 lg:my-8 lg:mt-8 xl:my-10 xl:mt-10 text-3xl md:text-4xl">
                                I need a higher loan amount
                            </h1>
                            <form onSubmit={(e) => this.handleOnSubmit(e)}>
                                <div className="flex flex-wrap w-full">
                                    <h2 className="openSans-SemiBold w-full text-black text-xl md:text-2xl mb-4 sm:mb-4 md:mb-4">
                                        Personal Details
                                    </h2>
                                    <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                        <InputForm
                                            label="First Name"
                                            errorText="Please enter first name"
                                            value={this.state.firstName}
                                            handlerOnChange={(e) => {
                                                this.setState({
                                                    firstName: e.target.value,
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                                        <InputForm
                                            label="Last Name"
                                            errorText="Please enter last name"
                                            value={this.state.lastName}
                                            handlerOnChange={(e) => {
                                                this.setState({
                                                    lastName: e.target.value,
                                                });
                                            }}
                                        />
                                    </div>
                                    <h2 className="openSans-SemiBold w-full text-black text-xl md:text-2xl mb-4 sm:mb-4 md:mb-4">
                                        Contact Details
                                    </h2>
                                    <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                        <InputForm
                                            label="Mobile No."
                                            prefix="+91"
                                            errorText="Please enter mobile no."
                                            value={this.state.mobile}
                                            handlerOnChange={(e) => {
                                                this.setState({
                                                    mobile: e.target.value,
                                                });
                                            }}
                                            prefixClass="mobile-code"
                                        />
                                    </div>
                                    <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                                        <InputForm
                                            label="Email ID"
                                            errorText="Please enter email id"
                                            value={this.state.email}
                                            handlerOnChange={(e) => {
                                                this.setState({
                                                    email: e.target.value,
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                        <SelectForm
                                            title="City"
                                            options={this.state.cityList}
                                            noneText="Select City"
                                            errorText="Please Select City"
                                            name="city"
                                            handlerOnChange={(e) =>
                                                this.setState({
                                                    city: e.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                                        <InputForm
                                            label="Loan Amount Required"
                                            prefix="Rs."
                                            errorText="Please enter loan amount required"
                                            value={this.state.loanRequired}
                                            handlerOnChange={(e) => {
                                                this.setState({
                                                    loanRequired:
                                                        e.target.value,
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="relative w-full mb-10">
                                        {/* {this.state.captcha
                                            ? htmlParse(this.state.captcha)
                                            : ""}
                                        <input
                                            type="button"
                                            className="captcha-refresh"
                                            value=""
                                            onClick={() =>
                                                this.handleOnCaptchaReset()
                                            }
                                        />
                                        <InputForm
                                            label="Enter Above Code"
                                            errorText="Please enter Captcha"
                                            handlerOnChange={(e) =>
                                                this.setState({
                                                    encryptedInput:
                                                        e.target.value,
                                                })
                                            }
                                        /> */}
                                        <div className="flex flex-wrap">
                                            <div className="m-3 w-full md:w-3/12 inline-flex justify-center md:justify-start">
                                                {this.state.captcha
                                                    ? htmlParse(
                                                          this.state.captcha
                                                      )
                                                    : ""}
                                                <input
                                                    type="button"
                                                    className="captcha-refresh"
                                                    value=""
                                                    onClick={() =>
                                                        this.handleOnCaptchaReset()
                                                    }
                                                />
                                            </div>
                                            <div className="w-full md:w-2/12 relative">
                                                <InputForm
                                                    label="Enter Code"
                                                    handlerOnChange={(e) =>
                                                        this.setLead({
                                                            captchaInput:
                                                                e.target.value,
                                                        })
                                                    }
                                                    errorText="Please Input Correct Captcha Code"
                                                    // error={this.state.captchaError}
                                                    errorClass="input-info-fix"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="relative w-full">
                                        <div className="text-left custom-inputs">
                                            <label className="inline-flex items-start md:items-center confirm-checkbox">
                                                <input
                                                    type="checkbox"
                                                    className="rounded bg-gray-200 border-transparent focus:border-transparent focus:bg-gray-200 text-gray-700 focus:ring-1 focus:ring-offset-2 focus:ring-gray-500 transition-all"
                                                    onChange={(e) => {
                                                        this.setState({
                                                            consentToContact: !this
                                                                .state
                                                                .consentToContact,
                                                        });
                                                    }}
                                                />
                                                <span></span>
                                                <span className="ml-2 text-sm md:text-base lg:text-xl">
                                                    I authorise HDFC Bank and
                                                    its representatives to
                                                    contact me with reference to
                                                    my application
                                                </span>
                                            </label>
                                        </div>
                                        <span
                                            className={
                                                "error-msg-relative text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm " +
                                                (this.state
                                                    .consentToContactError
                                                    ? ""
                                                    : "hidden")
                                            }
                                        >
                                            Please check
                                        </span>
                                    </div>
                                    <div className="w-full flex flex-wrap my-8">
                                        <button className="button-blue-bg text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue high-amt-apply-submit mb-2 mr-0 sm:mr-2 md:mr-2 lg:mr-3 xl:mr-4 transition-all">
                                            Submit
                                        </button>
                                        <button className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue mb-2 transition-all">
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </section>
                </div>
            </>
        );
    }
}

export default higherLoanApplyForm;
